import gql from "graphql-tag";

// ─── GraphQL Queries ────────────────────────────────────────────────────────

// Fetch classes
export const GET_CLASSES = gql`
  query($id: Int) {
    getExamClasses(id: $id) {
      id
      class
    }
  }
`;

// Fetch academic years
export const GET_ACADEMIC_YEARS = gql`
  query getAcademicYears($id: Int) {
    getAcademicYears(id: $id) {
      id
      academic_year
    }
  }
`;

// Fetch branches
export const GET_BRANCHES = gql`
  query getBranches($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        class_id
        section_name
      }
    }
  }
`;

// Fetch subjects by class
export const GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR = gql`
  query getClassSubjectsByAcademicYear(
    $academic_year_id: Int!
    $classIds: String
    $institute_id: Int!
  ) {
    getClassSubjectsByAcademicYear(
      academic_year_id: $academic_year_id
      classIds: $classIds
      institute_id: $institute_id
    ) {
      class_id
      checked
      subject_ids
      subject_names
    }
  }
`;

// Fetch employee details (lecturers)
export const GET_EMPLOYEE_DETAILS = gql`
  query($institute_id: Int, $branch_id: Int) {
    getEmployeeDetails(institute_id: $institute_id, branch_id: $branch_id) {
      employeeId
      employee_name
      branch_id
      subject_ids
      employee_type
    }
  }
`;

// Fetch categories
export const GET_LECTURE_CATEGORIES = gql`
  query($institute_id: Int!) {
    getLectureCategories(institute_id: $institute_id) {
      id
      institute_id
      video_category
      estatus
    }
  }
`;

// Fetch subcategories
export const GET_LECTURE_SUBCATEGORIES = gql`
  query($institute_id: Int!) {
    getLectureSubCategories(institute_id: $institute_id) {
      id
      video_sub_category
      description
      video_category_id
      estatus
    }
  }
`;

// Fetch all videos
export const GET_LECTURE_VIDEOS = gql`
  query($filter: LectureVideoFilterInput!) {
    getLectureVideos(filter: $filter) {
      id
      video_category_id
      video_sub_category_id
      paid_video
      lecturer_id
      institute_id
      branch_ids
      class_id
      subject_id
      title
      description
      video_url
      publish
      doc_file
      video_date
      estatus
      inserted_by
      inserted_time
      updated_by
      updated_time
    }
  }
`;

// ─── GraphQL Mutations ──────────────────────────────────────────────────────

// Video Categories CRUD
export const CREATE_LECTURE_CATEGORY = gql`
  mutation($input: LectureCategoryInput!) {
    createLectureCategory(input: $input)
  }
`;

export const UPDATE_LECTURE_CATEGORY = gql`
  mutation($input: LectureCategoryInput!) {
    updateLectureCategory(input: $input)
  }
`;

export const DELETE_LECTURE_CATEGORY = gql`
  mutation($id: Int!) {
    deleteLectureCategory(id: $id)
  }
`;

// Video Sub Categories CRUD
export const CREATE_LECTURE_SUBCATEGORY = gql`
  mutation($input: LectureSubCategoryInput!) {
    createLectureSubCategory(input: $input)
  }
`;

export const UPDATE_LECTURE_SUBCATEGORY = gql`
  mutation($input: LectureSubCategoryInput!) {
    updateLectureSubCategory(input: $input)
  }
`;

export const DELETE_LECTURE_SUBCATEGORY = gql`
  mutation($id: Int!) {
    deleteLectureSubCategory(id: $id)
  }
`;

// Videos CRUD
export const CREATE_LECTURE_VIDEO = gql`
  mutation($input: LectureVideoInput!) {
    createLectureVideo(input: $input)
  }
`;

export const UPDATE_LECTURE_VIDEO = gql`
  mutation($input: LectureVideoInput!) {
    updateLectureVideo(input: $input)
  }
`;

export const DELETE_LECTURE_VIDEO = gql`
  mutation($id: Int!) {
    deleteLectureVideo(id: $id)
  }
`;

// Cloudflare R2 Operations
export const INIT_R2_UPLOAD = gql`
  mutation initR2VideoUpload($params: R2UploadInitInput!) {
    initR2VideoUpload(params: $params) {
      presigned_url
      r2_key
      expires_at
    }
  }
`;

export const CONFIRM_R2_UPLOAD = gql`
  mutation confirmR2VideoUpload($params: R2VideoConfirmInput!) {
    confirmR2VideoUpload(params: $params) {
      id
      r2_key
      title
      description
      content_type
      file_size
      upload_status
      institute_id
    }
  }
`;

export const GET_R2_PLAYBACK_URL = gql`
  query getR2VideoPlaybackUrl($r2_key: String!) {
    getR2VideoPlaybackUrl(r2_key: $r2_key) {
      r2_key
      playback_url
      expires_at
    }
  }
`;

// File Upload Mutation for Document Attachments (similar to fee/expense invoice upload)
export const FILE_UPLOAD = gql`
  mutation FileUpload($params: FileUploadInput!) {
    fileUpload(params: $params) {
      uuid
      file_url
      file_name
    }
  }
`;
